<template>
	<div class="upload-page">
		<div class="header-bar">
			<span class="title-text">{{uploadArr.headerTitle||"📤上传评价"}}</span>
		</div>
		<!-- <div class="tab-group">
			
			<div class="tab-item" :class="{ active: activeTab === 'plan' }" @click="activeTab = 'plan'">
				📋实验方案
			</div>
			<div class="tab-item" :class="{ active: activeTab === 'design' }" @click="activeTab = 'design'">
				🎨设计图
			</div>
		</div> -->
		<div class="tab-group" v-if="uploadArr&&uploadArr.scoreItems&&uploadArr.scoreItems.length">
			<div class="tab-item" :class="{ active: activeTab === item.key }" @click="activeTab = item.key"
				v-for="item in uploadArr.scoreItems" :key="item.key">
				<!-- 图片图标：完美垂直居中 -->
				<img v-if="isImage(item.icon)" :src="item.icon" class="tab-icon">
				<!-- Emoji图标：完美垂直居中 -->
				<span v-else class="tab-emoji">{{ item.icon }}</span>

				<!-- 文字：垂直居中 -->
				<span class="tab-text">{{ item.name }}</span>
			</div>
		</div>
		<div class="upload-area" @click="openFile">
			<div class="preview-item" v-if="previewImgUrl">
				<img :src="previewImgUrl" class="preview-img" :style="{ transform: `rotate(${rotateDeg}deg)` }" />
				<div class="del-btn" @click.stop="delImage">×</div>
				<div class="rotate-btn" @click.stop="rotateImage">🔄</div>
			</div>

			<div v-else class="empty-content">
				<div class="camera-icon">
					<img style="max-width: 100px;" v-if="isImage(uploadArr.cameraIcon)" :src="uploadArr.cameraIcon" />
					<span v-else>{{uploadArr.cameraIcon||"📷"}}</span>
				</div>
				<p class="upload-text">点击上传图片</p>
				<p class="tip-text">支持 JPG、PNG 格式</p>
			</div>
		</div>

		<input type="file" ref="fileInput" accept="image/*" hidden @change="selectFile">

		<div class="btn-row">
			<button class="camera-btn" v-if="!previewImgUrl" @click="openFile">
				<img style="width: 30px;" v-if="isImage(uploadArr.cameraIcon)" :src="uploadArr.cameraIcon" />
				<span v-else>{{uploadArr.cameraIcon||"📷"}}</span>
				拍照上传
			</button>

			<button class="upload-oss-btn" v-else :disabled="uploading" @click="uploadToOSS">
				{{ uploading ? '评价中...' : '🔍开始评价' }}
			</button>
			<!-- <el-button @click="tocallAIApi()">测试</el-button> -->
		</div>

		<div v-if="AIfrom" style="overflow-y: auto;max-height: 300px;margin-left: 21px;margin-right: 20px;">
			<div>
				<div v-for="(item, index) in AIfrom.fullContent.split('\n')" :key="index">
					<div>{{item.name}}------{{item.value}} </div>
				</div>
			</div>
			<div class="follow-up-container">
				<div v-for="(item, index) in AIfrom.followUpList" :key="index">
					<div class="follow-up-item">{{item}} </div>
				</div>
			</div>
		</div>

		<el-dialog title="🍭 评价表 🍭" :visible.sync="dialogVisible" width="580px" @close="dialogVisible = false"
			class="kid-dialog" style="z-index: 3002;" :modal="false" :modal-append-to-body="false">
			<el-table :data="fullContent || []" border stripe style="width:100%; border-radius:16px; overflow:hidden;"
				height="360" class="kid-table" header-row-class-name="kid-table-header" row-class-name="kid-table-row">
				<el-table-column label="评价维度" prop="name" align="center" />
				<el-table-column label="表现" prop="value" align="center">
				  <template slot-scope="scope">
				     <div style="text-align:center" v-html="forHtml(scope.row.value)"></div>
				  </template>
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="success" round @click="dialogVisible = false">✅ 关闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		fullUploadImage
	} from '@/js/img.js'
	import {
		getModelWithoutKey
	} from "@/js/calssComponets.js"
	export default {
		name: "UploadImage",
		props: {
			courseClassId: {
				type: String,
				default: "0"
			},
		},
		data() {
			return {
				activeTab: "",
				previewImgUrl: "", // 预览用：原始图的blob
				selectFileObj: null, // 原始文件（永远不变）
				uploading: false,
				studentId: localStorage.getItem('userId') || '',
				AIfrom: null,
				fullContent: [],
				dialogVisible: false,
				login: null,
				rotateDeg: 0, // 仅控制CSS预览
				uploadArr: {},
			};
		},
		created() {
			this.foParms()
		},
		methods: {
			forHtml(val){
				console.log('val',val)
				if(!val) return ''
				if(val.toString().indexOf('\n')>-1){
					val = val.replace(/\n/g, "<br/>")
					const reg = /\*\*(.*?)\*\*/g;
					// 替换加粗
					val = val.replace(reg, '<strong>$1</strong>');
				}
				return val

			},
			async tocallAIApi() {
				let res = await this.callAIApi("温度", "coze_flow")
				console.log('res', res)
			},
			isImage(val) {
				return typeof val === 'string' && (val.startsWith('data:') || val.startsWith('http'))
			},
			async foParms() {
				try {
					let parmsString = localStorage.getItem('parms')
					let parms = JSON.parse(parmsString)
					this.uploadArr = parms.upload
					console.log('this.uploadArr', this.uploadArr)
					this.activeTab = this.uploadArr.scoreItems[0].key
				} catch (error) {

				}
			},
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			},
			noLogin() {
				if (this.login) this.login.close();
			},
			openFile() {
				this.$refs.fileInput.click();
			},

			selectFile(e) {
				const file = e.target.files[0];
				if (!file) return;
				// 释放旧blob
				if (this.previewImgUrl.startsWith('blob:')) URL.revokeObjectURL(this.previewImgUrl);
				this.selectFileObj = file;
				this.previewImgUrl = URL.createObjectURL(file); // 预览：原始图
				this.rotateDeg = 0; // 新图角度归零
			},

			delImage() {
				if (this.previewImgUrl.startsWith('blob:')) URL.revokeObjectURL(this.previewImgUrl);
				this.previewImgUrl = "";
				this.selectFileObj = null;
				this.rotateDeg = 0;
			},

			rotateImage() {
				this.rotateDeg = (this.rotateDeg + 90) % 360;
			},

			// 核心：只用【原始文件】+【当前rotateDeg】做一次旋转
			async getRotatedFile() {
				return new Promise((resolve) => {
					if (!this.selectFileObj || this.rotateDeg === 0) {
						resolve(this.selectFileObj); // 无旋转：直接返回原文件
						return;
					}
					const img = new Image();
					img.src = this.previewImgUrl; // 预览图（原始方向）
					img.onload = () => {
						const canvas = document.createElement('canvas');
						const ctx = canvas.getContext('2d');
						const angle = this.rotateDeg;

						// 宽高适配
						if (angle === 90 || angle === 270) {
							canvas.width = img.height;
							canvas.height = img.width;
						} else {
							canvas.width = img.width;
							canvas.height = img.height;
						}

						ctx.translate(canvas.width / 2, canvas.height / 2);
						ctx.rotate(angle * Math.PI / 180);
						ctx.drawImage(img, -img.width / 2, -img.height / 2);

						canvas.toBlob((blob) => {
							const rotatedFile = new File([blob], this.selectFileObj.name, {
								type: this.selectFileObj.type
							});
							resolve(rotatedFile);
						}, this.selectFileObj.type, 0.9);
					};
				});
			},
			async postUpdateScoreAndCase(res, score, content, arr, evaluateRes) {
				
				let followUpList = ''
				if (evaluateRes.followUpList.length > 0) {
					followUpList = JSON.stringify(evaluateRes.followUpList)
				}
				let totalTokens = 0
				if (evaluateRes.inputTokens && evaluateRes.outputTokens) {
					totalTokens = evaluateRes.inputTokens + evaluateRes.outputTokens
				}
				this.API.post(this.API.school.postChatUpdate, {
					id: res.id,
					score: score,
					keyId: arr.keyId,
					modelId: arr.modelId,
					schoolId:localStorage.getItem('orgId'),
					isCase: score < Number(this.uploadArr.scoreItems[this.activeTab - 1].goodScore) ? 0 : 1,
					test: evaluateRes.fullContent,
					aiContent: evaluateRes.aiContent,
					requestToken: evaluateRes.inputTokens || 0,
					consumeToken: evaluateRes.outputTokens || 0,
					followUpList: followUpList,
					aiid:evaluateRes.aiid
				}).then(ress => {
					console.log('ress', ress)
				})
			},

			async uploadToOSS() {
				this.AIfrom = null;
				if (!this.selectFileObj) return;
				this.uploading = true;
				this.loginOpen('评价中...');

				var imgType = this.activeTab.toString()
				var imgTypeName = this.uploadArr.scoreItems[this.activeTab - 1].name
				var arr = this.uploadArr.scoreItems[this.activeTab - 1];
				try {
					let keyRes = await getModelWithoutKey(arr.keyId)
					// 1. 生成【一次性旋转好】的文件
					
					if (!keyRes.isQuest) return this.$message('密钥已过期')
					let providerCode = keyRes.providerCode
					const rotatedFile = await this.getRotatedFile();

					// 2. 上传这个旋转好的文件
					const res = await fullUploadImage(
						rotatedFile,
						this.courseClassId,
						this.studentId,
						imgType,
						"student",
						imgTypeName
					);
					
					this.fullContent = [];
					const realImageUrl = await this.$oss.getUrl(res.url);
					// ❗关键：不要改 previewImgUrl！保持原始预览图，否则会变180°
					// this.previewImgUrl = realImageUrl.replace('http:', 'https:')
					console.log('realImageUrl', realImageUrl)
					let score = 0;
					
					let messageList=[{
						"content":realImageUrl.replace('http:', 'https:'),
						"fileType":"img"
					}]
					const evaluateRes = await this.callAIApi(
						messageList, // 给AI用上传后的地址
						providerCode,
						res.id,
					);
					let ismodel=false
					evaluateRes.data = evaluateRes.fullContent
					
					if (typeof evaluateRes.fullContent === 'string') {
						try {
							evaluateRes.data = JSON.parse(evaluateRes.fullContent)
						} catch {
							
							ismodel=true
						}
					}

					let fullContent = [];
					if (evaluateRes.data) {
						
						if(!ismodel){
							Object.keys(evaluateRes.data).forEach(key => {
								
								fullContent.push({
									"name": key,
									"value": evaluateRes.data[key]
								});
								if (key === '总分') score = evaluateRes.data[key];
							});
						}else{
							fullContent.push({
								"name": "异常",
								"value": evaluateRes.data
							});
						}
						console.log('fullContent', fullContent)
						this.fullContent = fullContent;
						this.dialogVisible = true;
						this.postUpdateScoreAndCase(res, score, evaluateRes.content, arr, evaluateRes);
					}
				} catch (e) {
					console.error(e);
					this.$message.error("上传或评价失败");
				} finally {
					this.uploading = false;
					this.previewImgUrl = null
					this.noLogin();
				}
			},

			async callAIApi(inputText, platform,id) {
				this.isAIApiProcessing = true;
				let publicPath = '';
				var isVue = this.API.isVue;
				const pathParts = window.location.pathname.split('/');
				if (isVue == 1) {
					if (pathParts[1] == 'test') publicPath = '/test';
				}
				if (isVue == 2) publicPath = '/api';
				if (isVue == 4) publicPath = '/v1/api';
				if (isVue == 5) publicPath = '/v1';

				var arr = this.uploadArr.scoreItems[this.activeTab - 1];
				const url = publicPath + "/sys/school/chat/stream/chat";

				// ========== 多平台解析规则配置 ==========
				const parseRules = {
					// 自有默认平台
					local: (data) => {
						const res = {
							content: "",
							follow: [],
							usage: {
								inputTokens: 0,
								outputTokens: 0,
								totalTokens: 0
							},
							conversationId: ""
						};
						if (data.type === "answer" && data.content) {
							res.content = data.content;
						}
						if (data.type === "follow_up" && data.content) {
							res.follow.push(data.content);
						}
						if (data.usage) {
							res.usage.inputTokens = data.usage.input_count || 0;
							res.usage.outputTokens = data.usage.output_count || 0;
							res.usage.totalTokens = data.usage.token_count || 0;
						}
						if (data.conversation_id) {
							res.conversationId = data.conversation_id;
						}
						return res;
					},

					// 扣子工作流 coze_flow未处理
					coze_flow: (data) => {
						const res = {
							content: "",
							follow: [],
							usage: {
								inputTokens: 0,
								outputTokens: 0,
								totalTokens: 0
							},
							conversationId: ""
						};
						console.log('data111:', data)
						//非流式
						if (data.content) {
							res.content += data.content

						}
						if (data.data) {

							res.usage.inputTokens = data.usage.input_count || 0;
							res.usage.outputTokens = data.usage.output_count || 0;
							res.usage.totalTokens = data.usage.token_count || 0;
							let cont = JSON.parse(data.data)
							res.content = cont.data
							res.conversationId = data.node_execute_uuid
						}
						if (data.usage) {
							res.usage.inputTokens = data.usage.input_count || 0
							res.usage.outputTokens = data.usage.output_count || 0
							res.usage.totalTokens = data.usage.token_count || 0
							// res.conversationId = data.node_execute_uuid
						}


						return res;
					},
					// 扣子智能体 coze_bot
					coze_bot: (data) => {
						const res = {
							content: "",
							follow: [],
							usage: {
								inputTokens: 0,
								outputTokens: 0,
								totalTokens: 0
							},
							conversationId: "",
							aiContent: ''
						};
						//流式建议咨询
						if (data.type === "follow_up") {
							res.follow.push(data.content)
						}
						if (data.type === "answer") {
							if (!data.created_at && data.content) {
								res.content += data.content
							}
							if (data.reasoning_content) {
								res.aiContent += data.reasoning_content
							}

						}
						//流式消耗
						if (data.status === "completed" && data.usage) {
							res.usage.inputTokens = data.usage.input_count || 0;
							res.usage.outputTokens = data.usage.output_count || 0;
							res.usage.totalTokens = data.usage.token_count || 0;
							res.conversationId = data.conversation_id;
						}
						//非流式文本
						if (data && data.usag) {
							res.usage.inputTokens = data.usag.input_count || 0;
							res.usage.outputTokens = data.usag.output_count || 0;
							res.usage.totalTokens = data.usag.token_count || 0;
							for (let i = 0; i < data.data.length; i++) {
								if (data.data[i].type === "answer") {
									res.aiContent = data.data[i].reasoning_content || ''
									res.content = data.data[i].content || ''
									res.conversationId = data.data[i].conversation_id || ''
								}
								if (data.data[i].type === "follow_up") {
									res.follow.push(data.data[i].content)
								}
							}
						}

						return res;
					},

					// 火山引擎 volc
					volc: (data) => {
						const res = {
							content: "",
							follow: [],
							usage: {
								inputTokens: 0,
								outputTokens: 0,
								totalTokens: 0
							},
							conversationId: "",
							aiContent: ''
						};
						//流式文本
						if (data.type === "response.output_text.delta") {
							res.content += data.delta
						}
						//流式思考过程
						if (data.type === 'response.reasoning_summary_text.delta') {
							res.aiContent += data.delta
						}
						//流式消耗
						if (data.type === "response.completed") {
							res.usage.inputTokens = data.response.usage.input_tokens || 0;
							res.usage.outputTokens = data.response.usage.output_tokens || 0;
							res.usage.totalTokens = data.response.usage.total_tokens || 0;
						}
						//非流式判断
						if (data.status === "completed" && !data.type) {
							res.aiContent = res.content = data.output[0].summary[0].text
							res.content = data.output[1].content[0].text || ''
							res.usage.inputTokens = data.usage.input_tokens || 0;
							res.usage.outputTokens = data.usage.output_tokens || 0;
							res.usage.totalTokens = data.usage.total_tokens || 0;
						}
						if (data.id) {
							res.conversationId = data.id;
						}
						return res;
					},
					deepseek: (data) => {
						const res = {
							content: "",
							follow: [],
							usage: {
								inputTokens: 0,
								outputTokens: 0,
								totalTokens: 0
							},
							conversationId: "",
							aiContent: ''
						};

						if (data && data.choices) {
							if (data.choices[0].delta) {

								if (data.choices[0].delta.content) {

									res.content += data.choices[0].delta.content
								}

							}
							if (data.choices[0].delta) {
								if (data.choices[0].delta.reasoning_content && data.choices[0].delta
									.reasoning_content != "null") {
									res.aiContent += data.choices[0].delta.reasoning_content
								}
							}
							if (data.choices[0].message) {
								if (data.choices[0].message.content) {
									res.content += data.choices[0].message.content
								}
								if (data.choices[0].message.reasoning_content) {
									res.aiContent += data.choices[0].message.reasoning_content
								}
							}
						}

						if (data.usage) {
							res.usage.inputTokens = data.usage.completion_tokens || 0;
							res.usage.outputTokens = data.usage.prompt_tokens || 0;
							res.usage.totalTokens = data.usage.total_tokens || 0;
						}
						return res;
					},
					dashScope: (data) => {
					    const res = {
					        content: "",
					        follow: [],
					        usage: {
					            inputTokens: 0,
					            outputTokens: 0,
					            totalTokens: 0
					        },
					        conversationId: "",
					        aiContent: ''
					    };
					
					    // 1. 顶层先取 output，百炼maas固定外层output
					    if (!data || !data.output || !Array.isArray(data.output.choices)) return res;
					    const choices = data.output.choices;
					    if (choices.length === 0) return res;
					    const choiceZero = choices[0];
					
					    // 2. 提取request_id 赋值给会话ID（后端最终入库用这个）
					    if (data.request_id) {
					        res.conversationId = data.request_id;
					    }
					
					    // 3. 取message（百炼流式无delta，所有增量都在message里）
					    if (choiceZero.message && typeof choiceZero.message === 'object') {
					        const msg = choiceZero.message;
					        // 拼接回答正文
							console.log('输出：',msg.content)
					        if (Array.isArray(msg.content)) {
					            if(msg.content[0]?.text){
									res.content += msg.content[0]?.text || '';
								}
					        }else{
								  res.content += msg.content
							}
					        // 拼接深度思考推理内容
					        if (msg.reasoning_content && msg.reasoning_content !== "null") {
					            res.aiContent += msg.reasoning_content;
					        }
					    }
					
					    // 4. 累加token用量
					    if (data.usage && typeof data.usage === 'object') {
					        res.usage.inputTokens = Number(data.usage.input_tokens || 0);
					        res.usage.outputTokens = Number(data.usage.output_tokens || 0);
					        res.usage.totalTokens = Number(data.usage.total_tokens || 0);
					    }
					
					    return res;
					},
				};

				// 兜底：标识不存在则走默认 local
				const currentParser = parseRules[platform] || parseRules.local;

				try {
					let fullContent = "";
					let tokenInfo = {
						inputTokens: 0,
						outputTokens: 0,
						totalTokens: 0
					};
					let aiContent = ''
					let conversationId = null;
					let followUpList = [];
					const token = localStorage.getItem('token');

					const res = await fetch(url, {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							Authorization: token || ""
						},
						body: JSON.stringify({
							content: inputText,
							modelId: arr.modelId,
							keyId: arr.keyId,
							// modelId:3 ,
							// keyId:2,
							courseClassId: this.courseClassId,
							studentId: this.studentId,

						})
					});

					if (!res.ok) {
						console.error("接口请求异常", res.status);
						return null;
					}

					const reader = res.body.getReader();
					const decoder = new TextDecoder();
					let buffer = "";

					while (true) {
						const {
							done,
							value
						} = await reader.read();
						if (done) break;

						buffer += decoder.decode(value, {
							stream: true
						});
						// 兼容 \n / \r\n 换行
						const lines = buffer.split(/\r?\n/);
						buffer = lines.pop() || "";

						for (const line of lines) {
							const trimLine = line.trim();
							if (!trimLine || !trimLine.startsWith("data:")) continue;

							const jsonStr = trimLine.replace("data:", "").trim();
							if (jsonStr === "[DONE]" || jsonStr === '"[DONE]"') continue;

							try {
								let data = jsonStr
								if (typeof jsonStr === 'string') {
									try {
										data = JSON.parse(jsonStr);
									} catch (e) {
										continue;
									}
								}

								const parseResult = currentParser(data);

								// 拼接回答文本
								if (parseResult.content) {
									fullContent += parseResult.content;

								}
								if (parseResult.aiContent) {
									aiContent += parseResult.aiContent
								}
								// 追加追问列表
								if (parseResult.follow.length) {
									followUpList.push(...parseResult.follow);
								}
								// 更新Token
								if (parseResult.usage) {
									tokenInfo = parseResult.usage;
								}
								// 仅首次赋值会话ID
								if (parseResult.conversationId && !conversationId) {
									conversationId = parseResult.conversationId;
									this.saveConversationId(conversationId,id);
								}
							} catch (e) {
								// 解析失败静默跳过，不中断流
								// console.warn("解析异常", e, jsonStr);
								continue;
							}
						}
					}
						// console.log()+
						console.log('fullContent',fullContent)
						if(fullContent.indexOf('```')>-1&&fullContent.indexOf('```')<3){
							fullContent=fullContent.replace(/```/g,'')
							fullContent = fullContent.replaceAll("json", "");
						}
						
						
					return {
						fullContent,
						aiContent,
						inputTokens: tokenInfo.inputTokens,
						outputTokens: tokenInfo.outputTokens,
						followUpList
					};
				} catch (err) {
					console.error("AI调用异常：", err);
					return null;
				} finally {
					this.isAIApiProcessing = false;
				}
			},

			async saveConversationId(conversationId,id) {
				if (this.hasSavedConversationId) return;
				try {
					await this.API.post(this.API.school.postChatUpdate, {
						schoolId:localStorage.getItem('orgId'),
						id:id,
						aiid: conversationId
					});
					this.hasSavedConversationId = true;
				} catch (e) {
					console.error("保存会话ID失败", e);
				}
			},
		}
	};
</script>

<style scoped>
	.upload-page {
		height: calc(100vh - 80px);
		width: 100%;
		background: #fff9e6;
		display: flex;
		flex-direction: column;
	}

	.header-bar {
		height: 70px;
		background: #c5e1a5;
		color: #8b5a2b;
		font-size: 26px;
		font-weight: bold;
		display: flex;
		align-items: center;
		justify-content: center;
		border-bottom-left-radius: 20px;
		border-bottom-right-radius: 20px;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
	}

	.tab-group {
		display: flex;
		background: #fff;
		margin: 10px 16px;
		border-radius: 12px;
		padding: 4px;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
		gap: 4px;
		/* 按钮之间间距 */
	}

	/* 核心：整个 tab 内部垂直居中 */
	.tab-item {
		flex: 1;
		/* 🔥 核心：自动平分宽度 / 自适应 */
		display: flex;
		align-items: center;
		/* 垂直居中 */
		justify-content: center;
		/* 文字+图标居中 */
		gap: 6px;
		padding: 8px 12px;
		border-radius: 8px;
		cursor: pointer;
		white-space: nowrap;
		/* 不换行 */
	}

	.tab-item.active {
		background: #409eff;
		color: #fff;
	}

	/* 图片大小 + 垂直居中 */
	.tab-icon {
		width: 25px;
		height: 25px;
		object-fit: contain;
		flex-shrink: 0;
		/* 不压缩 */
	}

	/* Emoji 大小 + 居中 */
	.tab-emoji {
		font-size: 20px;
		line-height: 1;
		flex-shrink: 0;
	}

	/* 文字垂直居中 */
	.tab-text {
		line-height: 25px;
	}

	.upload-area {
		height: 200px;
		margin: 10px 16px;
		border: 2px dashed #c5e1a5;
		border-radius: 16px;
		background: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.empty-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 6px;
	}

	.camera-icon {
		font-size: 50px;
	}

	.upload-text {
		font-size: 18px;
		color: #333;
		margin: 0;
	}

	.tip-text {
		font-size: 14px;
		color: #999;
		margin: 0;
	}

	.preview-item {
		width: 160px;
		height: 160px;
		position: relative;
		border-radius: 12px;
		overflow: hidden;
		background: #f5f5f5;
	}

	.preview-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.del-btn {
		position: absolute;
		top: 4px;
		right: 4px;
		width: 22px;
		height: 22px;
		background: rgba(0, 0, 0, 0.5);
		color: #fff;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
	}

	.rotate-btn {
		position: absolute;
		top: 4px;
		left: 4px;
		width: 22px;
		height: 22px;
		background: rgba(0, 0, 0, 0.5);
		color: #fff;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		cursor: pointer;
	}

	.btn-row {
		display: flex;
		gap: 10px;
		margin: 10px 16px 20px;
	}

	.camera-btn {
		height: 50px;
		flex: 1;
		background: #c5e1a5;
		color: #8b5a2b;
		border: none;
		border-radius: 12px;
		font-size: 18px;
		font-weight: bold;
		gap: 8px;
		align-items: center;
		/* 🔥 核心：垂直居中 */
		margin: 0 auto;
		display: block;
	}

	/* 图片图标 */
	.camera-icons {
		width: 30px;
		height: 30px;
		/* 必须加高度，才能完美居中 */
		object-fit: contain;
		flex-shrink: 0;
	}

	.upload-oss-btn {
		flex: 1;
		height: 50px;
		background: #4CAF50;
		color: #fff;
		border: none;
		border-radius: 12px;
		font-size: 18px;
		font-weight: bold;
	}

	.upload-oss-btn:disabled {
		opacity: 0.7;
	}

	.follow-up-container {
		margin-top: 12px;
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
	}

	.follow-up-item {
		padding: 6px 14px;
		background-color: #f5f7f9;
		border: 1px solid #e8e9eb;
		border-radius: 18px;
		font-size: 14px;
		color: #333;
		cursor: pointer;
		transition: all 0.2s;
	}

	.follow-up-item:hover {
		background-color: #e9edf1;
		border-color: #dcdfe6;
	}

	.ai-scroll-container::-webkit-scrollbar {
		width: 8px;
	}

	.ai-scroll-container::-webkit-scrollbar-track {
		background: #e6f2ff;
		border-radius: 4px;
	}

	.ai-scroll-container::-webkit-scrollbar-thumb {
		background: #66b1ff;
		border-radius: 4px;
	}

	.ai-scroll-container::-webkit-scrollbar-thumb:hover {
		background: #4096ff;
	}

	.ai-scroll-container::-webkit-scrollbar-button {
		display: none;
	}

	.el-loading-text {
		font-size: 28px !important;
		color: #fff !important;
	}

	.el-loading-spinner {
		font-size: 30px !important;
	}
</style>